// ABOUTME: RTK Query API slice for MFA endpoints.
// ABOUTME: Provides hooks for MFA setup, verification, disable, and recovery code management.
import { rootSlice } from "../createRootSlice";

export const mfaApiSlice = rootSlice.injectEndpoints({
  endpoints: (builder) => ({
    getMfaStatus: builder.query({
      query: () => ({
        url: '/mfa/status',
        method: 'GET',
      }),
      providesTags: ['MfaStatus'],
    }),
    setupMfa: builder.mutation({
      query: () => ({
        url: '/mfa/setup',
        method: 'POST',
      }),
    }),
    verifyMfaSetup: builder.mutation({
      query: (body) => ({
        url: '/mfa/verify-setup',
        method: 'POST',
        body,
      }),
      invalidatesTags: ['MfaStatus'],
    }),
    disableMfa: builder.mutation({
      query: (body) => ({
        url: '/mfa/disable',
        method: 'PUT',
        body,
      }),
      invalidatesTags: ['MfaStatus'],
    }),
    verifyMfa: builder.mutation({
      query: (body) => ({
        url: '/mfa/verify',
        method: 'POST',
        body,
      }),
    }),
    useRecoveryCode: builder.mutation({
      query: (body) => ({
        url: '/mfa/recovery',
        method: 'POST',
        body,
      }),
    }),
    regenerateCodes: builder.mutation({
      query: (body) => ({
        url: '/mfa/regenerate-codes',
        method: 'POST',
        body,
      }),
      invalidatesTags: ['MfaStatus'],
    }),
  }),
});

export const {
  useGetMfaStatusQuery,
  useSetupMfaMutation,
  useVerifyMfaSetupMutation,
  useDisableMfaMutation,
  useVerifyMfaMutation,
  useUseRecoveryCodeMutation,
  useRegenerateCodesMutation,
} = mfaApiSlice;
